// extracted by mini-css-extract-plugin
export default {"logoBox":"SignIn_logoBox__K3CnW","gLogin":"SignIn_gLogin__8WQ8i"};